<div class="d-flex flex-row">
  <div class="grid" *ngFor="let col of table">
    <ng-container *ngFor="let row of col">
      <ng-container *ngIf="(row.value$ | async) as value">
        <div class="label">{{row.label | translate}}:</div>
        <div class="value">{{value}}</div>
        <div class="unit">{{row.unit}}</div>
      </ng-container>
    </ng-container>
  </div>
</div>
